import React from 'react'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from 'date-fns/locale';
registerLocale('pt-br', ptBR)

const _DatePicker = ({
  filtersList,
  filters,
  setFilters,
  filter,
  index,
  setFiltersList,
  pagination,
  setPagination
}) => {
  return (
    <DatePicker
      isClearable
      dateFormat="dd/MM/yyyy"
      selected={filtersList[filter].data[index].value}
      onChange={async (date) => {
        let _aux = {
          ...filtersList,
          [filter]: {
            ...filtersList[filter],
            data: {
              ...filtersList[filter].data,
              [index]: {
                ...filtersList[filter].data[index],
                value: date
              }
            }
          }
        }
        setFilters({
          ...filters, [filter]: {
            data: { ..._aux[filter].data }
          }
        })        
        setPagination({ ...pagination, current_page: 1 })
        setFiltersList(_aux)
      }}
      className='form-control'
      locale="pt-br"
    />
  )
}

export default _DatePicker